'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setQuickshopSliderListeners = exports.setupQuickshopSlider = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Slider = require('components/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var featureSliderSettings = {
  currentSlider: null

  // need to track the current slider for our other events
};var setupQuickshopSlider = exports.setupQuickshopSlider = function setupQuickshopSlider() {
  _Slider2.default.initSliders().then(function (sliders) {
    featureSliderSettings.currentSlider = sliders[0];
  });
};

var moveSlideByOne = function moveSlideByOne(arrow) {
  var toChangeBy = parseInt(arrow.getAttribute('data-slide-nav'), 10);
  var toGoTo = featureSliderSettings.currentSlider.slider.selectedIndex + toChangeBy;
  // check if we want to wrap around to the other end of the slider
  if (toGoTo < 0) {
    toGoTo = featureSliderSettings.currentSlider.slider.slides.length - 1;
  } else if (toGoTo >= featureSliderSettings.currentSlider.slider.slides.length) {
    toGoTo = 0;
  }
  PubSub.publish(_Constants2.default.updateSliderSlide, {
    slider: featureSliderSettings.currentSlider,
    slideTo: toGoTo
  });
};

var setQuickshopSliderListeners = exports.setQuickshopSliderListeners = function setQuickshopSliderListeners() {
  document.addEventListener('click', function (event) {
    // First check if a thumbnail was clicked and swap to its image
    var quickshopTrigger = _Dom2.default.quickshopThumbnail.replace(/[\[\]']+/g, '');
    if (event.target.hasAttribute(quickshopTrigger)) {
      var slideNumber = event.target.getAttribute(quickshopTrigger);
      PubSub.publish(_Constants2.default.updateSliderSlide, {
        slider: featureSliderSettings.currentSlider,
        slideTo: slideNumber
      });
    }
    // listen for the prev/next slider buttons
    if (event.target.hasAttribute('data-slide-nav')) {
      moveSlideByOne(event.target);
    }
    // check if the clicked element was in the arrows
    var sliderArrows = document.querySelectorAll('[data-slide-nav] svg');
    [].concat((0, _toConsumableArray3.default)(sliderArrows)).forEach(function (arrow) {
      if (arrow.contains(event.target)) {
        moveSlideByOne(arrow.parentNode);
      }
    });
  });
};